import React from 'react';
import { connect } from 'react-redux';
import { Row } from '../Layout';
import Save from './Save';
import Cancel from './Cancel';
import { sharedSelectors, sharedOperations } from '../../ducks';
import type { RootState } from '../../../store/types';
import { CancelWrapper, SaveChangesWrapper, Spinner } from './FormButtons.styles';

type OwnProps = {
  isSubmitDisabled: boolean;
  isSubmitting: boolean;
};

type StateProps = {
  isMobile: boolean;
};

type DispatchProps = {
  navigateToAccountPage: (url: string) => void;
};

function FormButtons({
  isMobile,
  isSubmitDisabled,
  isSubmitting,
  navigateToAccountPage
}: OwnProps & StateProps & DispatchProps) {
  const onCancelClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const personalDetailsUrl = '/personal-details';
    navigateToAccountPage(personalDetailsUrl);
  };

  return (
    <Row>
      {!isMobile && (
        <CancelWrapper>
          <Cancel onClick={onCancelClick}>Cancel</Cancel>
        </CancelWrapper>
      )}
      <SaveChangesWrapper>
        <Save type="submit" disabled={isSubmitDisabled}>
          {isSubmitting ? <Spinner /> : 'Save Changes'}
        </Save>
      </SaveChangesWrapper>
    </Row>
  );
}

const mapDispatchToProps = {
  navigateToAccountPage: sharedOperations.navigateToAccountPage
};

const mapStateToProps = (state: RootState) => ({
  isMobile: sharedSelectors.getIsMobile(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormButtons);
